import { isSet, optionsToKeyValuePairs } from "../../../../../../utils/commonUtils";
import { computationRules1 } from "./DrugScreenCollection";

export const DefaultScreen=(props)=>{
 const charts = [
    {
      type: "Grid",
      col: "col-md-3",
      data: [
        {
          type: "PatientDetails",
          employeeDetails: props.employeeDetails,
          visitDetails: props.visitDetails,
        },
        {
          type: "CompanyDetails",
          companyDetails: props.companyDetails,
        },
      ],
    },
    {
      type: "Tab",
      col: "col-md-9",
      data: [
        {
          id: "Fields",
          label: "Fields",
          data: [
            {
              label: "Fields",
              fields: [
                  {
                      label: "Notes",
                      col: "col-12",
                      type: "TextArea",
                      name: "notes",
                  },
                  {
                      label: "User Name",
                      col: "col-12",
                      type: "TextInput",
                      name: "user_name",
                  },
                  {
                      label: "Date",
                      col: "col-12",
                      type: "Date",
                      name: "date",
                  },
                // {
                //   label: 'Result Status',
                //   type: 'SelectList',
                //    col: "col-12",
                //   // options:[],
                //   options: isSet(props.lookupsOptions['chartResult'], []),
                //   name: 'status',
                //   id: 'status',
                // },
              ],
            },
            {
              label: "Review / Completion",
              labelStyle: "fw-semibold",
              fields: [
                {
                  type: "ProviderSignOff",
                  col: "col-12",
                  fields: [
                    { label: "Signature PIN", name: "provider_pin", col: "col-12" },
                    { label: "Signature", type: "NewSignature", name: "provider_signature", col: "col-12" },
                    { label: "Date", type: "Date", name: "signed_date", col: "col-12" },
                    {
                      label: "Final Results",
                      type: "SelectList",
                      name: "status",
                      col: "col-12",
                      // Standard shared status options
                      options: optionsToKeyValuePairs(
                        [
                          "Not Started",
                          "Pending",
                          "Normal",
                          "Abnormal",
                          "Negative",
                          "Positive",
                          "Dispensed",
                          "Administered",
                          "Failed",
                          "Passed",
                          "Non-Negative",
                          "Cancelled",
                          "Inconclusive",
                        ],
                        false
                      ),
                      statusBasedColor: true,
                    },
                    {
                      label: "Activity Status",
                      type: "SelectList",
                      name: "activity_status",
                      col: "col-12",
                      options: optionsToKeyValuePairs(
                        [
                          "Not Started",
                          "Pending",
                          "Pending Lab Confirmation",
                          "Pending MRO Confirmation",
                          "Ready for Review",
                          "Completed",
                          "Cancelled",
                        ],
                        false
                      ),
                      statusBasedColor: true,
                    },
                  ],
                },
              ],
            }
          ],
        },
        {
          id: "Images",
          label: "Images",
          data: []
        }
      ],
    },
  ];
  const buttons = { };
  const defaultValue = {
    status:'Not Started',
    activity_status:'Not Started',
  };
  const headers = [{
    type: 'Tab',
    data: [
      {
        label: 'Fields',
        id: 'Fields'
      },
      {
        label: 'Images',
        id: 'Images'
      }
    ]
  }];
    return {
    charts,
    defaultValue,
    buttons,
    headers,
    // computationFunction: (formData, key) => computationRules(formData, key),
    computationFunction: (formData, key) => ({
      ...computationRules1(formData, key),
    }),
  };
}